module.exports = __webpack_public_path__ + "img/activity-banner-default.d9d641c0.png";